module.exports = __webpack_public_path__ + "img/ford-commercial-display-vehicles.a4b68c8d.png";